/**
 * Bancos do Brasil pelo código COMPE (3 dígitos), para a etapa 4 do
 * assistente de ativação (PLANO, seção 6.3 — "lista de bancos com busca",
 * T4.3). Não é a lista completa do Bacen: são os bancos com conta digital
 * ou de varejo mais usados pelos prestadores da Controlapag. `bankCode` vai
 * direto no `CreatePaymentAccountDto.bank.bankCode`
 * (`api/src/payment-account/dto/create-payment-account.dto.ts`).
 */
export interface Bank {
  code: string;
  name: string;
}

export const BANKS: Bank[] = [
  { code: '001', name: 'Banco do Brasil' },
  { code: '003', name: 'Banco da Amazônia' },
  { code: '004', name: 'Banco do Nordeste' },
  { code: '021', name: 'Banestes' },
  { code: '025', name: 'Banco Alfa' },
  { code: '033', name: 'Santander' },
  { code: '037', name: 'Banco do Estado do Pará' },
  { code: '041', name: 'Banrisul' },
  { code: '047', name: 'Banco do Estado de Sergipe' },
  { code: '070', name: 'BRB - Banco de Brasília' },
  { code: '077', name: 'Banco Inter' },
  { code: '084', name: 'Uniprime' },
  { code: '085', name: 'Cooperativa Central Ailos' },
  { code: '089', name: 'Cooperativa de Crédito Rural (Credisan)' },
  { code: '097', name: 'Credisis' },
  { code: '104', name: 'Caixa Econômica Federal' },
  { code: '107', name: 'Banco Bocom BBM' },
  { code: '133', name: 'Cresol' },
  { code: '151', name: 'Banco do Estado do Rio Grande do Sul (Banrisul S.A.)' },
  { code: '197', name: 'Stone Pagamentos' },
  { code: '208', name: 'Banco BTG Pactual' },
  { code: '212', name: 'Banco Original' },
  { code: '218', name: 'Banco BS2' },
  { code: '237', name: 'Bradesco' },
  { code: '246', name: 'Banco ABC Brasil' },
  { code: '260', name: 'Nu Pagamentos (Nubank)' },
  { code: '265', name: 'Banco Fator' },
  { code: '290', name: 'PagBank (PagSeguro)' },
  { code: '318', name: 'Banco BMG' },
  { code: '320', name: 'Banco Industrial e Comercial (China)' },
  { code: '322', name: 'Cooperativa de Crédito CrediCitrus' },
  { code: '323', name: 'Mercado Pago' },
  { code: '336', name: 'Banco C6' },
  { code: '341', name: 'Itaú Unibanco' },
  { code: '359', name: 'Zema Crédito' },
  { code: '366', name: 'Banco Société Générale Brasil' },
  { code: '380', name: 'PicPay' },
  { code: '389', name: 'Banco Mercantil do Brasil' },
  { code: '399', name: 'Kirton Bank (antigo HSBC)' },
  { code: '403', name: 'Cora' },
  { code: '422', name: 'Banco Safra' },
  { code: '453', name: 'Banco Rural' },
  { code: '456', name: 'Banco MUFG Brasil' },
  { code: '461', name: 'Asaas' },
  { code: '463', name: 'Banco Fibra' },
  { code: '479', name: 'Banco ItaúBank (antigo Citibank)' },
  { code: '533', name: 'Banco Voiter' },
  { code: '600', name: 'Banco Luso Brasileiro' },
  { code: '604', name: 'Banco Industrial do Brasil' },
  { code: '610', name: 'Banco VR' },
  { code: '611', name: 'Banco Paulista' },
  { code: '623', name: 'Banco Pan' },
  { code: '633', name: 'Banco Rendimento' },
  { code: '634', name: 'Banco Triângulo' },
  { code: '637', name: 'Banco Sofisa' },
  { code: '655', name: 'Banco Votorantim (BV)' },
  { code: '707', name: 'Banco Daycoval' },
  { code: '735', name: 'Banco Neon' },
  { code: '739', name: 'Banco Cetelem' },
  { code: '741', name: 'Banco Ribeirão Preto' },
  { code: '743', name: 'Banco Semear' },
  { code: '745', name: 'Citibank' },
  { code: '748', name: 'Sicredi' },
  { code: '752', name: 'BNP Paribas Brasil' },
  { code: '756', name: 'Sicoob' },
  { code: '780', name: 'Efí (antigo Gerencianet)' },
];

/**
 * Busca por nome ou código, sem acentuação e sem diferenciar maiúsculas —
 * usada no campo com busca da etapa 4 (`app/components/payments`).
 */
export function searchBanks(query: string): Bank[] {
  const normalized = query.trim().normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  if (!normalized) return BANKS;
  return BANKS.filter(
    (bank) =>
      bank.code.includes(normalized) ||
      bank.name.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().includes(normalized),
  );
}

export function findBankByCode(code: string): Bank | undefined {
  return BANKS.find((bank) => bank.code === code);
}
